export default {"src":"/_next/static/media/back.74c9724c.svg","height":9,"width":14};